export const NAV = {
  logo: "nav-logo-link",
  home: "nav-home-link",
  services: "nav-services-link",
  benefits: "nav-benefits-link",
  about: "nav-about-link",
  contact: "nav-contact-link",
  loginButton: "nav-login-button",
  ctaButton: "nav-cta-button",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HOME = {
  heroTitle: "hero-title",
  heroCta: "hero-cta-button",
  heroSecondaryCta: "hero-secondary-cta",
  statSavingsMonth: "stat-savings-month",
  statSavingsYear: "stat-savings-year",
  statSavingsPercent: "stat-savings-percent",
  statExperience: "stat-experience",
  fundingChart: "funding-cuts-chart",
  featureGrid: "feature-grid",
  partnersSection: "partners-section",
  ctaSection: "home-cta-section",
};

export const SERVICES = {
  pageTitle: "services-page-title",
  stepCard: (i) => `services-step-${i}`,
};

export const BENEFITS = {
  pageTitle: "benefits-page-title",
  benefitItem: (i) => `benefit-item-${i}`,
};

export const ABOUT = {
  pageTitle: "about-page-title",
};

export const CONTACT = {
  pageTitle: "contact-page-title",
  inputName: "contact-input-name",
  inputPharmacy: "contact-input-pharmacy",
  inputEmail: "contact-input-email",
  inputPhone: "contact-input-phone",
  inputAddress: "contact-input-address",
  inputMessage: "contact-input-message",
  submitButton: "contact-submit-button",
  successMessage: "contact-success-message",
};

export const FOOTER = {
  container: "site-footer",
  emailLink: "footer-email-link",
};
